module.exports = __webpack_public_path__ + "static/media/WindowletteringprogressJettieRaesAsheville2020.482a9732.webp";